import ViewDatails from "./ViewDatails";

export default ViewDatails;
